import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { CALC_CATEGORIES } from "../utils/categories";
import { cn } from "@/lib/utils";

const CURVE_LABEL: Record<string, { label: string; color: string }> = {
  straight: { label: "Straight-line", color: "bg-sky-100 text-sky-800" },
  accelerated: { label: "Accelerated", color: "bg-rose-100 text-rose-800" },
  flat: { label: "No depreciation", color: "bg-emerald-100 text-emerald-800" },
};

export default function CategoryDepreciationLegend() {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-5 text-left hover:bg-muted/30 transition-colors"
        aria-expanded={open}
      >
        <div>
          <div className="text-sm font-semibold">How each category depreciates</div>
          <div className="text-xs text-muted-foreground mt-0.5">
            Defaults used by this calculator (industry-standard, editable per item).
          </div>
        </div>
        <ChevronDown className={cn("h-4 w-4 text-muted-foreground transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div className="px-5 pb-5 animate-fade-in">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {CALC_CATEGORIES.map((c) => {
              const cv = CURVE_LABEL[c.curve];
              return (
                <div key={c.id} className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-xs">
                  <div>
                    <div className="font-medium">{c.label}</div>
                    <div className="text-[10px] text-muted-foreground">Lifespan ~{c.lifespan} yrs</div>
                  </div>
                  <span className={`shrink-0 ml-2 px-2 py-0.5 rounded-full text-[10px] font-semibold ${cv.color}`}>
                    {cv.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
